import axios from "axios";
import constants from "@/config/constants";
import _ from "lodash";

function initialState() {
    return {
        all: [],
        loading: false,
        page_title: "Booth Presets"
    }
}

const getters = {
    all:         state => state.all,
    total:         state => state.all.length,
    edit_id:         state => state.edit_id,
    loading:       state => state.loading,
}

const actions = {
    fetchData({ commit, state }) {
        commit('setLoading', true)
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };

        return axios.get(constants.API_URL + '/api/presets', {headers: headers})
            .then(response => {
                commit('setAll', response.data.data)
                return response;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    destroyData({ commit, state }, id) {
        commit('setLoading', true);
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        axios.delete(constants.API_URL + '/api/presets/'+id,{headers: headers})
            .then(response => {
                commit('setAll', state.all.filter((item) => {
                    return item.id != id
                }))
            })
            .catch(error => {
                let message = error.response.data.message || error.message
                commit('setError', message)
                console.log(message)
            })
    },
    
    resetState({ commit }) {
        commit('resetState')
    },
    setEditId({ commit }, id) {
        commit('setEditId', id)
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setEditId(state, id) {
        state.edit_id = id
    },
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
